import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { BsDot, BsFillShareFill } from "react-icons/bs";
import { MdPhonelink } from "react-icons/md";
import { FaHeadset, FaUserCog } from "react-icons/fa";
import List from "../../molecules/List/List";
import Agent from "../../molecules/Agent/Agent";
import img2 from "../../../images/all/27.jpg";
import "./Homepage.css";
import Testimonials from "../../molecules/Testimonials/Testimonials";
import Footer from "../../molecules/Footer/Footer";

import Info from "../../atoms/Info/Info";
import Foot from "../../molecules/Foot/Foot";
import Navbar from "../../molecules/Navbar/Navbar";
import AuthContext from "../../../context/UserSummary";

const Homepage = () => {
  const { isLoggedIn } = useContext(AuthContext);

  const decor = {
    textDecoration: "none",
  };

  return (
    <div className="home-wrapper">
      <Navbar />
      <div className="home-container">
        <section className="home-head">
          <div className="home-position">
            <div className="home-head-css">
              <div className="">
                <h4>Real Estate Searching Platform</h4>
                <h2>
                  Find The House of Your Dream <br />
                  Using Our Platform
                </h2>
              </div>
              <div className="flex-options">
                <div className="flexxing">
                  <div className="input-div what-are">
                    <input
                      type="text"
                      className="what"
                      placeholder="What are you looking for?"
                    />
                  </div>
                  <div className="flexxx">
                    <div className="all-status">
                      <select data-placeholder="All Categories" className="all">
                        <option>All Statuses</option>
                        <option>For Rent</option>
                        <option>For Sale</option>
                      </select>
                    </div>
                    <div className="all-status">
                      <select data-placeholder="All Categories" className="all">
                        <option>All Cities</option>
                        <option>New York</option>
                        <option>London</option>
                        <option>Paris</option>
                        <option>Kiev</option>
                        <option>Moscow</option>
                        <option>Dubai</option>
                        <option>Rome</option>
                        <option>Beijing</option>
                      </select>
                    </div>
                  </div>
                  <button className="home-btn">Search</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="trry">
        <div className="wrap-mini">
          <div className="list-starter">
            <div className="home-list">
              <div className="dot">
                <Link style={decor} to="/">
                  <li className="home">Home</li>
                </Link>{" "}
                <BsDot className="dotted-icon" />
              </div>
            </div>
            <div className="share">
              <BsFillShareFill className="share-icon" />
              <p className="share-text">Share</p>
            </div>
          </div>
        </div>
      </div>
      <div className="home-bg">
        <div className="home-section">
          <div className="offer">
            <p>Browse hot offers</p>
          </div>
          <List listAll={false} />
          {isLoggedIn ? (
            <div className="all-props">
              <Link style={decor} to="/listings">
                <li>View All Properties</li>
              </Link>
            </div>
          ) : null}
        </div>
        <div className="section-two-bg">
          <div className="section-two-wrapper">
            <div className="section-two">
              <div className="sec-two-left">
                <h2>Why Choose Our Properties</h2>
                <h5>Browse through the site to find out more about us .</h5>

                <div className="mic">
                  <div className="mic-icon">
                    <FaHeadset />
                  </div>
                  <div className="mic-writeup">
                    <h3>24 Hours Support</h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </p>
                  </div>
                </div>
                <div className="mic">
                  <div className="mic-icon">
                    <FaUserCog />
                  </div>
                  <div className="mic-writeup">
                    <h3>User Admin Panel</h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </p>
                  </div>
                </div>
                <div className="mic">
                  <div className="mic-icon">
                    <MdPhonelink />
                  </div>
                  <div className="mic-writeup">
                    <h3>Mobile Friendly</h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </p>
                  </div>
                </div>
              </div>
              <div className="sec-two-right">
                <img className="sec-two-img" src={img2} alt="img2" />
              </div>
            </div>
          </div>
        </div>
        <div className="section-three">
          <div className="sec-three-header">
            <h4>The Best Agents</h4>
            <h3>Meet Our Agents</h3>
          </div>
          <Agent />
        </div>
        <Info />
        <div className="section-three">
          <div className="sec-three-header">
            <h4>TESTIMONILAS</h4>
            <h3>What Our Clients Say</h3>
          </div>
          <Testimonials />
        </div>
        <div className="section-footer">
          <div className="inner-footer">
            <Footer />
          </div>
        </div>
        <div className="mini-footer">
          <div className="mini-footerr">
            <Foot />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
